'use strict';

import moment from 'moment';
import {GraphDateRange} from '@app/core/model/GraphDateRange';

export function getDefaultDateRange(): GraphDateRange {
  let startDate;
  let endDate;

  if (moment().startOf('month').date() === moment().date()) {
    startDate = moment().subtract(1, 'months').startOf('month');
    endDate = moment().subtract(1, 'months').endOf('month');
  } else {
    startDate = moment().startOf('month');
    endDate = moment();
  }

  return new GraphDateRange(startDate, endDate);
}
